/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { TOTPVerifyAttestationData } from './TOTPVerifyAttestationData';
import {
    TOTPVerifyAttestationDataFromJSON,
    TOTPVerifyAttestationDataFromJSONTyped,
    TOTPVerifyAttestationDataToJSON,
    TOTPVerifyAttestationDataToJSONTyped,
} from './TOTPVerifyAttestationData';

/**
 * 
 * @export
 * @interface TOTPVerifyAttestation
 */
export interface TOTPVerifyAttestation {
    /**
     * 
     * @type {string}
     * @memberof TOTPVerifyAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPVerifyAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {TOTPVerifyAttestationData}
     * @memberof TOTPVerifyAttestation
     */
    data?: TOTPVerifyAttestationData;
}



/**
 * Check if a given object implements the TOTPVerifyAttestation interface.
 */
export function instanceOfTOTPVerifyAttestation(value: object): value is TOTPVerifyAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function TOTPVerifyAttestationFromJSON(json: any): TOTPVerifyAttestation {
    return TOTPVerifyAttestationFromJSONTyped(json, false);
}

export function TOTPVerifyAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPVerifyAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : TOTPVerifyAttestationDataFromJSON(json['data']),
    };
}

export function TOTPVerifyAttestationToJSON(json: any): TOTPVerifyAttestation {
    return TOTPVerifyAttestationToJSONTyped(json, false);
}

export function TOTPVerifyAttestationToJSONTyped(value?: TOTPVerifyAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': TOTPVerifyAttestationDataToJSON(value['data']),
    };
}

